module.exports = __webpack_public_path__ + "img/calogero-2024.be22e1fd.jpg";